// Plan checkout via the Spring backend. The server owns pricing: we send only
// the tier slug and billing period, and redirect to the Stripe-hosted page.
const apiUrl = process.env.REACT_APP_API_URL;

function getBasicAuthHeader() {
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  const encodedCredentials = btoa(`${username}:${password}`);
  return `Basic ${encodedCredentials}`;
}

class PaymentComponent {
  /**
   * @param {string} tier e.g. "professional"
   * @param {string} billingPeriod "monthly" | "yearly"
   */
  async makePayment(tier, billingPeriod = 'monthly') {
    try {
      const userId = localStorage.getItem('userId');
      const response = await fetch(`${process.env.REACT_APP_API_URL || apiUrl}/api/stripe/checkout-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
          Authorization: getBasicAuthHeader(),
        },
        body: JSON.stringify({ userId, tier, billingPeriod }),
      });
      const data = await response.json();
      if (!response.ok || !data.url) {
        console.error('Checkout session error:', data.error || response.status);
        return;
      }
      window.location.href = data.url;
    } catch (error) {
      console.error('Checkout error:', error);
    }
  }
}

export default PaymentComponent;
